"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeStringToParts = exports.partsToTimeString = exports.getPartValues = exports.getPartPositions = exports.getPartOptions = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _padStart = _interopRequireDefault(require("lodash/padStart"));

var _range = _interopRequireDefault(require("lodash/range"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _find = _interopRequireDefault(require("lodash/find"));

var _timeString = require("./../_utils/time-string");

var _intlDateTimeFormat = require("./../_utils/intl-date-time-format");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// The hours of the day formatted "HH:00:00"
var hours = (0, _range["default"])(0, 24).map(function (hour) {
  return "".concat((0, _padStart["default"])(hour, 2, 0), ":00:00");
}); // Used for minutes or seconds formatted "##" (ex. "59")

var zeroToSixty = (0, _range["default"])(0, 60).map(function (i) {
  return "".concat((0, _padStart["default"])(i, 2, 0));
});
var defaultFormat = {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
};
/**
 * Returns an array of "time part" options formatted to a locale and format object.
 * Array is ordered how a localized time string would be constructed.
 *
 * getPartOptions("zh-CN") ->
 * [
 *   { type: "dayPeriod", options: ["上午", "下午"] },
 *   { type: "hour", options: ["12", "01", "02",..., "11"] },
 *   { type: "literal", value: ":" },
 *   { type: "minute", options: ["00", "01",..., "59"] }
 * ]
 */

var getPartOptions = function getPartOptions(locale) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFormat;
  // Get the parts (hour, minute, second, dayPeriod or whatever else is in format)
  // for each hour
  var partsPerHour = hours.map(_timeString.createDateAtTime).map(function (hour) {
    return (0, _intlDateTimeFormat.intlDateTimeFormatToParts)(hour, format, locale);
  });

  var _partsPerHour = (0, _slicedToArray2["default"])(partsPerHour, 1),
      sampleHour = _partsPerHour[0]; // Record which parts exists and the order they appear


  var parts = sampleHour.map(function (_ref) {
    var type = _ref.type;
    return type;
  }); // Defer to hardcoded values for seconds and minutes and ignore literals

  var lookupParts = parts.filter(function (part) {
    return part !== "second" && part !== "minute" && part !== "literal";
  }); // For each hour, add unique values for each part to our collection of values

  var values = partsPerHour.reduce(function (values, hourParts) {
    var _iterator = _createForOfIteratorHelper(lookupParts),
        _step;

    try {
      var _loop = function _loop() {
        var part = _step.value;

        var _ref2 = (0, _find["default"])(hourParts, function (_ref3) {
          var type = _ref3.type;
          return type === part;
        }) || {},
            value = _ref2.value;

        if (value && !(0, _includes["default"])(values[part], value)) {
          values[part] = values[part] ? values[part].concat(value) : [value];
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return values;
  }, {
    minute: zeroToSixty,
    second: zeroToSixty
  });
  return parts.map(function (type, index) {
    return type === "literal" ? {
      type: type,
      value: sampleHour[index].value
    } : {
      type: type,
      options: values[type]
    };
  });
};
/**
 * Given an array of parts, returns an object whose keys are the part types
 * with options (non literals) and whose values are an object of the start/end
 * position. Useful when updating the formatted time string ("04:-- PM") or
 * constructing the ISO time string ("04:55:55")
 *
 * getPartPositions([
 *   { type: "hour", options: ["12",...]},
 *   { type: "literal", value: ":" },
 *   { type: "minute", options: ["01", ...]}
 * ]) ->
 * { hour: { start: 0, end: 1 }, minute: { start: 3, end: 4 }}
 */


exports.getPartOptions = getPartOptions;

var getPartPositions = function getPartPositions(parts) {
  var cursor = 0;
  return parts.reduce(function (partPositions, _ref4) {
    var type = _ref4.type,
        options = _ref4.options,
        value = _ref4.value;

    var _ref5 = options ? options[0] : value,
        length = _ref5.length;

    if (options) partPositions[type] = {
      start: cursor,
      end: cursor + length
    };
    cursor += length;
    return partPositions;
  }, {});
};
/**
 * Parses a formatted time string with the help of part positions.
 *
 * getPartPositions("10:--:A3 PM", { hour: { start: 0, end: 1 }, ...}) ->
 * { hour: "10", minute: "--", second: "A3", dayPeriod: "PM" }
 */


exports.getPartPositions = getPartPositions;

var getPartValues = function getPartValues(string, partPositions) {
  var partValues = {};

  for (var part in partPositions) {
    var _partPositions$part = partPositions[part],
        start = _partPositions$part.start,
        end = _partPositions$part.end;
    partValues[part] = string.slice(start, end);
  }

  return partValues;
};
/**
 * Returns parts given a time string "HH:mm:ss", format, and locale.
 * timeStringToParts("23:59:59", { hour: "2-digit", minute: "2-digit" },"en-US") ->
 * [
 *   { "type": "hour", "value": "11" },
 *   { "type": "literal", "value": ":" },
 *   { "type": "minute", "value": "59" },
 *   { "type": "literal", "value": " " },
 *   { "type": "dayPeriod", "value": "PM" }
 * ]
 */


exports.getPartValues = getPartValues;

var timeStringToParts = function timeStringToParts(timeString, format, locale) {
  return (0, _intlDateTimeFormat.intlDateTimeFormatToParts)((0, _timeString.createDateAtTime)(timeString), format, locale);
}; // Resolves a formatted hour (ex. the 8 in "08:30 PM") to the hour cycle and an
// evening flag.
// resolveHourToCycle(8, "h12", true) -> 20
// Read more on hourCycle https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle


exports.timeStringToParts = timeStringToParts;

var resolveHourToCycle = function resolveHourToCycle(hour, hourCycle, evening) {
  switch (hourCycle) {
    case "h24":
      return hour === 24 ? 0 : hour;

    case "h23":
      return hour;

    case "h12":
      return hour === 12 && !evening ? 0 : hour < 12 && evening ? hour + 12 : hour;

    case "h11":
      return hour === 0 && evening ? 12 : evening ? hour + 12 : hour;
  }
};
/**
 * Constructs a time string "HH:mm:ss" out of part values, part options, format
 * and locale.
 */


var partsToTimeString = function partsToTimeString(partValues, partOptions, format, locale) {
  // Get numeric value of each time part
  var hour = Number(partValues["hour"]);
  var minute = Number(partValues["minute"]);
  var second = Number(partValues["second"] || 0); // Determine if we are in the evening and need to resolve hours to get ISO time

  var _intlDateTimeFormatRe = (0, _intlDateTimeFormat.intlDateTimeFormatResolvedOptions)(format, locale),
      hourCycle = _intlDateTimeFormatRe.hourCycle;

  var _ref6 = (0, _find["default"])(partOptions, ["type", "dayPeriod"]) || {},
      dayPeriodOptions = _ref6.options;

  var dayPeriod = partValues["dayPeriod"];
  var evening = dayPeriod && dayPeriodOptions[1] && dayPeriod.toLocaleLowerCase(locale) === dayPeriodOptions[1].toLocaleLowerCase(locale); // Resolve hour to hour cycle and if we are in the evening

  var resolvedHour = resolveHourToCycle(hour, hourCycle, evening); // Construct final time string

  return "".concat((0, _padStart["default"])(resolvedHour, 2, 0), ":").concat((0, _padStart["default"])(minute, 2, 0), ":").concat((0, _padStart["default"])(second, 2, 0));
};

exports.partsToTimeString = partsToTimeString;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/time-picker/time-parts.js
// module id = 881
// module chunks = 0